import { ArrowBackIcon } from '@chakra-ui/icons'
import { Box, Text } from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks'
import { Link } from 'react-router-dom'

interface IPageHeaderpropstype {
  bgcolor: string
  heading: string
}

export const PageHeader = (props: IPageHeaderpropstype) => {
  const {isDesktop} = useDeviceType();
  return (
    <Box paddingX='20' w='100%' paddingY='1' bg={props.bgcolor}>
      <Link to='/'>
        <Text color='#F47321' display={`${isDesktop?'block':'none'}`}>
          {' '}
          <ArrowBackIcon /> Back
        </Text>
      </Link>

      <Text w='100%' textAlign='center' fontSize='xl'>
        {' '}
        {props.heading}
      </Text>
    </Box>
  )
}
